module.exports = __webpack_public_path__ + "img/edge.7c1c6aa9.png";